export default __webpack_public_path__ + "static/459-ca269b967a388b90413a1c2cc8d2b97b.gif";